import React from "react";
import { useUser } from "../context/UserContext";

export default function HamburgerButton({ open, onToggle })
{
  return (
    <button
      type="button"
      className="hamburger2-btn"
      aria-label={open ? "Fechar menu" : "Abrir menu"}
      aria-expanded={open}
      onClick={onToggle}
    >
    <div className={`hamburger2 ${open ? "is-active" : ""}`}>
        <span className="bar bar1" />
        <span className="bar bar2" />
        <span className="bar bar3" />
        <span className="bar bar4" />
      </div>

    </button>
  );
}
